import React from 'react';

import { cn } from '@/utils/classname';

interface EmptyStateContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Consistent container for empty states in aegis-management tabs.
 * Provides bordered visual treatment matching TanStackTable wrapper pattern.
 */
export const EmptyStateContainer: React.FC<EmptyStateContainerProps> = ({
  children,
  className,
}) => (
  <div
    className={cn(
      'border-chariot-stroke flex min-h-0 flex-1 flex-col overflow-hidden rounded-md border',
      className
    )}
    data-testid="empty-state-container"
  >
    {children}
  </div>
);
